/** *****************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2024, 2025. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 ****************************************************************************** */

// copied from:
// https://github.ibm.com/ibmcloud/cloud-pal-community/blob/8adcdb05a31205b122067c1b649c525db8bf224d/src/components/Connected/RefResolverPicker/hooks/useApiConfig.js

/*
Configs are controlled here. The config is used to generate a data hook API call. It can be used for other types of API calls as well
*/
var config = {
  name: "useApi",
  // REQUIRED Name of the data hook, should be the same as the file name.
  type: "retrieve",
  // REQUIRED Data Hook type, currently retrieve or modify
  uri: "/devops/ref-resolver/api/v1/ui/accounts/{{0}}/providers/{{1}}/apis/{{2}}",
  // REQUIRED URL that will be called with this request
  method: "GET",
  documentation: {
    params: {}
  }
};
export default config;